// extracted by mini-css-extract-plugin
module.exports = {"chips":"styles_chips__IOtED","chips_scrollable":"styles_chips_scrollable__rWjJ_"};